module.exports = __webpack_public_path__ + "favicon/favicon_192.d2899d23.png";